import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M10 21v-1.9q0-.526.262-.988.263-.462.713-.737 1.15-.675 2.412-1.025A9.7 9.7 0 0 1 16 16q1.35 0 2.613.35t2.412 1.025q.45.275.713.738T22 19.1V21zm-8 0V9l8-6 5.375 4.05a4.8 4.8 0 0 0-3.125 1.638Q11 10.1 11 12q0 .775.213 1.463.212.687.612 1.287-.5.2-.962.412a9 9 0 0 0-.913.488q-.9.525-1.425 1.463A4 4 0 0 0 8 19.1V21zm14-6a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 13 12q0-1.25.875-2.125A2.9 2.9 0 0 1 16 9q1.25 0 2.125.875T19 12t-.875 2.125A2.9 2.9 0 0 1 16 15" }, null, -1)
  ])))
}
export default { render: render }